module.exports = __webpack_public_path__ + "img/other.97ec6ffc.jpg";